module.exports = __webpack_public_path__ + "img/knu_gallery8.78f90cb6.jpg";